import React, { useState, useEffect, useRef } from 'react';
import {
    createDefaultImageReader,
    createDefaultImageWriter,
    setPlugins,
    locale_en_gb,
    plugin_crop,
    plugin_crop_locale_en_gb,
    plugin_finetune,
    plugin_finetune_locale_en_gb,
    plugin_annotate,
    plugin_annotate_locale_en_gb,
    plugin_resize,
    plugin_resize_locale_en_gb,
    plugin_filter,
    plugin_filter_defaults,
    plugin_filter_locale_en_gb,
    markup_editor_locale_en_gb,
    createDefaultShapePreprocessor,
    markup_editor_defaults,
    plugin_finetune_defaults,
    processDefaultImage
} from '@pqina/pintura';
import { PinturaEditor } from '@pqina/react-pintura';
import {
    plugin_trim,
    plugin_trim_locale_en_gb
} from '@pqina/pintura-video';
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';
import axios from 'axios';
import Utilities from 'app/utility/Utilities.js';

const MediaEditor = (props) => {
    const [ media, setMedia ] = useState(null);
    const [ isGettingPreview, setIsGettingPreview ] = useState(false);
    const [ videoInfo, setVideoInfo ] = useState({});
    const [ uploadError, setUploadError ] = useState('');
    const [ requestVars, setRequestVars ] = useState({});
    const [ thumbnailUrl, setThumbnailUrl ] = useState(null);

    const editorRef = useRef();

    const chooseThumbnail = () => {
        if (editorRef.current) {
            let editor = editorRef.current.editor,
                nextVideoInfo = Utilities.deepClone(videoInfo);

            nextVideoInfo.cover_ms = editor.imageCurrentTime;
            setVideoInfo(nextVideoInfo);

            generateThumbnail(editor);
        }
    };

    const generateThumbnail = (editor) => {
        return new Promise((resolve) => {
            processDefaultImage(editor.imageFile, {
                ...editor.imageState,
                imageWriter: {
                    targetSize: {
                        width: 100
                    }
                }
            }).then(({ dest }) => {
                const nextThumbnailUrl = URL.createObjectURL(dest);
                if (thumbnailUrl) {
                    URL.revokeObjectURL(thumbnailUrl);
                }
                setThumbnailUrl(nextThumbnailUrl);
                resolve((nextThumbnailUrl));
            })
        });
    }

    const onImageProcessed = (image) => {
        let formData = new FormData();
        formData.append('type', 'postMedia');
        formData.append('media[]', image.dest);

        MediaUploader({
            formData,
            responseCallback: (response) => {
                let data = response.data,
                    hasErrors = false;

                if (props.accessoryServiceId) {
                    props.attachMedia(data, props.accessoryServiceId, media.hash);
                } else {
                    props.attachMedia(data, 0, media.hash);
                }

                if (data.errors !== undefined && data.errors.validation !== undefined && data.errors.validation.media !== undefined) {

                }

                // pop the modal stack
                if (!hasErrors) {
                    props.cancelAction();
                }

            },
            errorCallback: (error) => {
                if (error.response) {
                    let errorData = error.response.data.errors || null,
                        errorMsgs = [];

                    const extractErrors = (obj) => {
                        if (obj && Object.keys(obj).length) {
                            Object.keys(obj).map((key) => {
                                if (typeof obj[key] === 'string') {
                                    errorMsgs.push(obj[key]);
                                } else if (Object.keys(obj[key])) {
                                    extractErrors(obj[key]);
                                }
                            });
                        }
                    };

                    // session died before upload
                    if (error.response.status === 403) {
                        window.location.reload();
                        return;
                    }

                    if (error.response.status === 413) {

                        return;
                    }

                    extractErrors(errorData);

                    if (errorMsgs.length) {

                    } else if (error.response.data.error) {

                    }

                } else if (error.message) {

                }

            }
        });

    }

    const getPreview = () => {
        let formData = new FormData(),
            apiUrl = props.app.config.apiUrl;

        formData.append('requestVars', JSON.stringify(requestVars));
        setIsGettingPreview(true);

        axios({
            url: `${apiUrl}/post/videoPreview`,
            method: 'POST',
            data: formData,
            headers: { "Content-type": "application/json" },
            withCredentials: true,
            responseType: 'json'
        })
        .then((response) => {
            let data = response.data;

            if (data.jobStatus !== "DONE") {
                setTimeout(() => {
                    getPreview()
                }, 1000);
            } else {
                // store preview url
                let nextVideoInfo = {
                    hash: media.hash,
                    preview: data.videoUrl,
                    serviceId: requestVars.serviceId,
                };
                if (Object.keys(videoInfo).length) {
                    nextVideoInfo = Object.assign(nextVideoInfo, videoInfo);
                }
                setVideoInfo(nextVideoInfo);
                setIsGettingPreview(false);
            }

        })
        .catch((error) => {
            console.log(error);
            setIsGettingPreview(false);
        });
    }

    const createUploadWriter = () => [
        [
            async (state, options, onprogress) => {
                let nextVideoInfo = Utilities.deepClone(videoInfo);

                nextVideoInfo.image_state = state.imageState;

                props.storeVideoInfo(nextVideoInfo);
                props.cancelAction();

                return {
                    ...state
                }

            },
            'upload'
        ]
    ];

    let onProcessed = null;

    useEffect(() => {
        if (props.videoInfo.length) {
            let video = props.videoInfo.find(({ hash, serviceId }) => { return hash === props.accessoryHash && serviceId === parseInt(props.accessoryServiceId); });
            if (video) {
                setVideoInfo(video);
            }
        }

        if (props.accessoryHash) {
            let mediaFile = props.mediaThumbs.find(({hash}) => { return hash === props.accessoryHash});
            if (mediaFile) {
                setMedia(mediaFile);
            }
        } else {
            setMedia(props.mediaThumbs[0]);
        }

        return () => {
            if (editorRef.current) {
                editorRef.current.destroy();
            }
            if (thumbnailUrl) {
                URL.revokeObjectURL(thumbnailUrl);
            }
        }
    }, []);

    useEffect(() => {
        if (Object.keys(requestVars).length) {
            getPreview();
        }
    }, [requestVars]);

    useEffect(() => {
        let video = null;

        if (videoInfo.length) {
            video = videoInfo.find(({ hash, serviceId }) => { return hash === media.hash && serviceId === parseInt(props.accessoryServiceId); });
        }

        if (!video && media && media.type.match("video")) {
            setRequestVars({
                hash: media.hash,
                serviceId: props.accessoryServiceId
            });
        }

    }, [media]);

    useEffect(() => {
        if (Object.keys(videoInfo).length) {
            props.storeVideoInfo(videoInfo);
        }
    }, [videoInfo])

    let editorConfig = {},
        enableUtils = true,
        enableToolbar = true,
        thumbnailPicker = null,
        filterFunctions = undefined,
        filterOptions = undefined;

    if (media === null) {
        return null;
    }

    if (media.type.match("video")) {
        //setPlugins(plugin_trim, plugin_crop, plugin_resize, plugin_filter);
        setPlugins(plugin_trim);
        enableUtils = true;
        // set to true when more plugins are loaded
        enableToolbar = true;
        editorConfig = {
            locale: {
                ...locale_en_gb,
                ...plugin_trim_locale_en_gb,
                //...plugin_crop_locale_en_gb,
                //...plugin_resize_locale_en_gb,
                //...plugin_filter_locale_en_gb
            },
            imageReader: createDefaultImageReader(),
            imageWriter: createUploadWriter(),
            trimEnableSplit: false,
            trimEnableUpdateCurrentTimeOnTrim: true
        };

        // filterFunctions = {
        //     ...plugin_filter_defaults.filterFunctions
        // };

        // filterOptions = [
        //     ...plugin_filter_defaults.filterOptions
        // ];

        if (props.hasVideoThumbSupport(props.accessoryServiceId)) {
            thumbnailPicker = (
                <div className="thumbnail-picker-wrapper">
                    <div className="thumbnail-preview">
                        {thumbnailUrl ? (
                            <img src={thumbnailUrl} className="thumb-image"/>
                        ) : null}
                    </div>
                    <div className="thumbnail-picker-button-wrapper">
                        <div className="thumbnail-picker-button" onClick={chooseThumbnail}>
                            Save current frame as thumbnail
                        </div>
                    </div>
                </div>
            );
        }

    } else if (media.type.match("image")) {
        setPlugins(plugin_crop, plugin_finetune, plugin_annotate);
        editorConfig = {
            locale: {
                ...locale_en_gb,
                ...plugin_crop_locale_en_gb,
                ...plugin_finetune_locale_en_gb,
                ...plugin_annotate_locale_en_gb,
                ...markup_editor_locale_en_gb,
            },
            imageReader: createDefaultImageReader(),
            imageWriter: createDefaultImageWriter(),
            ...markup_editor_defaults,
            ...plugin_finetune_defaults,
            shapePreprocessor: createDefaultShapePreprocessor()

        };
        onProcessed = onImageProcessed;
    }

    let mediaSrc = media.original,
        video = null;

    if (props.videoInfo.length) {
        video = props.videoInfo.find(({hash, serviceId}) => { return hash === media.hash && serviceId === props.accessoryServiceId; });
        if (video && video.preview !== undefined) {
            mediaSrc = video.preview;
        }
        //  if (video.trim_points) {
        //     editorConfig.imageTrim = [video.trim_points];
        // }
    }

    return (
        <div>
            <div className="media-editor-wrapper">
                {isGettingPreview ? (
                    <div className="media-editor-processing">
                        Loading video... <i className="fa fa-circle-o-notch fa-spin"></i>
                    </div>
                ) : (
                    <PinturaEditor
                        id="media-editor-main"
                        {...editorConfig}
                        src={mediaSrc}
                        ref={editorRef}
                        enableToolbar={enableToolbar}
                        enableUtils={enableUtils}
                        onProcess={onProcessed}
                        filterFunctions={filterFunctions}
                        filterOptions={filterOptions}
                        onLoad={() => {
                            let video = null;
                            if (props.videoInfo.length) {
                                video = props.videoInfo.find(({hash, serviceId}) => { return hash === media.hash && serviceId === props.accessoryServiceId; });
                                if (video.cover_ms) {
                                    editorRef.current.editor.imageCurrentTime = video.cover_ms
                                    generateThumbnail(editorRef.current.editor);
                                }
                                if (video.image_state) {
                                    editorRef.current.editor.history.write(video.image_state);
                                }
                            }
                        }}>
                    </PinturaEditor>
                )}
            </div>
            {thumbnailPicker}
        </div>
    );
};

export default MediaEditor;
